/**
 * Spinner — DS Atom
 */

import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'action' | 'neutral';
  label?: string;
  className?: string;
}

export function Spinner({ size = 'md', variant = 'primary', label, className = '' }: SpinnerProps) {
  return (
    <div className={`${styles.wrapper} ${className}`} role="status">
      <div className={`${styles.spinner} ${styles[size]} ${styles[variant]}`} />
      {label && <span className={styles.label}>{label}</span>}
      <span className="visually-hidden">Chargement...</span>
    </div>
  );
}
